module.exports = __webpack_public_path__ + "img/t_0031.629221f9.gif";